module.exports = __webpack_public_path__ + "assets/img/71aba91254f7d4c31a0d07c6ba88b476.svg";